module.exports = __webpack_public_path__ + "img/roostervis.8bc0fe5d.webp";